import {gql} from 'apollo-angular';

export const GET_ROOKIE_DISTRICT_DATE_RANGE = gql`
  query GetRookieDistrictDateRange($districtId: Int!) {
    rookieDistrictDateRange(districtId: $districtId)
  }
`;
